import { FunctionComponent, useEffect, useState } from 'react'
import { Box, Select as MuiSelect, Switch, TextField, Typography, makeStyles, InputAdornment } from '@material-ui/core'
import { cities, countries, provinces } from 'common/select-options'
//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { OnboardingQuestion } from 'common/types'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Flag, LocationCity, MapRounded } from '@material-ui/icons'
import { Select } from 'common/molecules/Select/Select'
import { InputFieldGroup } from 'common/molecules/InputFieldGroup/InputFieldGroup'

const StyledSelect = styled(MuiSelect)`
  && {
    background-color: ${props => props.theme.colors.bgPrimary};
  }
`
const StyledTextField = styled(TextField)`
  && .MuiInputBase-root {
    background-color: ${props => props.theme.colors.bgPrimary};
  }
`

const StyledInputAdornment = styled(InputAdornment)`
  && {
    padding-left: 0.875rem;
  }
`
interface LocationProps {
  location: string[]
  setLocation: Function
  questionIndex: number
  handleChange: Function
  editProfileQuestions?: OnboardingQuestion[]
  getQuestionIndex?: Function
}

const useStyles = makeStyles(() => ({
  select: {
    width: '300px',
    minWidth: '0px !important'
  }
}))

export const Location: FunctionComponent<LocationProps> = ({
  location,
  setLocation,
  questionIndex,
  handleChange,
  editProfileQuestions,
  getQuestionIndex
}) => {
  const theme = useTheme()
  const classes = useStyles()
  const { isDevice } = useScreenSizes()
  const [displayMessage, setDisplayMessage] = useState('none')
  const [isUSOrCanada, setIsUSOrCanada] = useState(null)

  useEffect(() => {
    setLocation(location)
    setIsUSOrCanada(location[0] === 'United States' || location[0] === 'Canada')
  }, [location])

  const handleSelect = (index: number, e: any) => {
    if (index === 0) {
      location[1] = ''
      location[2] = ''
    }
    if (index === 1 && isUSOrCanada) {
      location[2] = ''
    }
    location[index] = e.target.value
    setLocation([...location])
  }

  return (
    <Box>
      <Box padding="0.5em 0">
        <Box
          display="flex"
          flexWrap={isDevice ? 'wrap' : 'nowrap'}
          justifyContent="space-between"
          alignItems="center"
          mb="0.2em"
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" component="p" align="left" style={{ fontWeight: 'bold' }}>
              Country
              <Box color={theme.colors.error} component="span" padding="0 0.5em 0 0">
                <sup>*</sup>
              </Box>
            </Typography>
          </Box>
          <Box>
            {editProfileQuestions && (
              <Box
                display="flex"
                paddingLeft={isDevice && displayMessage !== 'none' ? '10em' : '0'}
                alignItems="center"
                justifyContent="flex-end"
                padding="0.5em 0 0 0"
                width="100%"
              >
                <Switch
                  color="primary"
                  size="small"
                  onChange={(e: any) => {
                    handleChange(
                      editProfileQuestions?.indexOf(editProfileQuestions?.find(x => x?.question === 'Show Country')),
                      e,
                      false,
                      '',
                      false,
                      true
                    )
                  }}
                  checked={
                    editProfileQuestions[
                      getQuestionIndex(
                        editProfileQuestions?.find(x => x?.question === 'Show Country')?.question,
                        editProfileQuestions
                      )
                    ]?.userAnswer === 'true'
                      ? true
                      : false
                  }
                />
                <Typography variant="body2">Show</Typography>
              </Box>
            )}
          </Box>
        </Box>

        <Box style={{ minWidth: 120 }}>
          <Select
            width="100%"
            theme={theme}
            menuItemList={countries.map(val => ({ ...val, value: val?.label }))}
            value={location[0]}
            MenuProps={{ classes: { paper: classes.select } }}
            startAdornment={
              <StyledInputAdornment position="start">
                <Flag />
              </StyledInputAdornment>
            }
            fullWidth
            disableUnderline
            onChange={(e: any) => {
              handleSelect(0, e)
              handleChange(questionIndex, location, false, '', true)
            }}
          ></Select>
        </Box>
      </Box>

      <Box padding="0.5em 0">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.2em">
          <Box>
            <Typography component="p" variant="body2" align="left" style={{ fontWeight: 'bold' }}>
              Province / State
              <Box color={theme.colors.error} component="span" padding="0 0.5em 0 0">
                <sup>*</sup>
              </Box>
            </Typography>
          </Box>
          <Box>
            {editProfileQuestions && (
              <Box display="flex" alignItems="center" padding="0.5em 0 0 0" width="100%">
                <Switch
                  color="primary"
                  size="small"
                  onChange={(e: any) => {
                    handleChange(
                      editProfileQuestions?.indexOf(editProfileQuestions?.find(x => x?.question === 'Show Province')),
                      e,
                      false,
                      '',
                      false,
                      true
                    )
                  }}
                  checked={
                    editProfileQuestions[
                      getQuestionIndex(
                        editProfileQuestions?.find(x => x?.question === 'Show Province')?.question,
                        editProfileQuestions
                      )
                    ]?.userAnswer === 'true'
                      ? true
                      : false
                  }
                />
                <Typography variant="body2">Show</Typography>
              </Box>
            )}
          </Box>
        </Box>
        <Box width="100%">
          {isUSOrCanada && (
            <Select
              value={location[1]}
              width="100%"
              theme={theme}
              menuItemList={provinces
                ?.find(province => province.country === location[0])
                ?.states.map(val => ({ ...val, value: val?.label }))}
              fullWidth
              disableUnderline
              startAdornment={
                <StyledInputAdornment position="start">
                  <MapRounded />
                </StyledInputAdornment>
              }
              MenuProps={{ classes: { paper: classes.select } }}
              onChange={(e: any) => {
                handleSelect(1, e)
                handleChange(questionIndex, location, false, '', true)
              }}
            ></Select>
          )}
          {!isUSOrCanada && (
            <InputFieldGroup
              value={location[1] === 'undefined' ? '' : location[1]}
              fullWidth
              onChange={(e: any) => {
                handleSelect(1, e)
                handleChange(questionIndex, location, false, '', true)
              }}
            />
          )}
        </Box>
      </Box>

      <Box padding="0.5em 0 1em">
        <Box
          display="flex"
          flexWrap={isDevice ? 'wrap' : 'nowrap'}
          justifyContent="space-between"
          alignItems="center"
          mb="0.2em"
        >
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography component="p" variant="body2" align="left" style={{ fontWeight: 'bold' }}>
              City
              <Box color={theme.colors.error} component="span" padding="0 0.5em 0 0">
                <sup>*</sup>
              </Box>
            </Typography>
          </Box>
          {editProfileQuestions && (
            <Box
              display="flex"
              paddingLeft={isDevice && displayMessage !== 'none' ? '10em' : '0'}
              alignItems="center"
              justifyContent="flex-end"
              padding="0.5em 0 0 0"
            >
              <Switch
                color="primary"
                size="small"
                onChange={(e: any) => {
                  handleChange(
                    editProfileQuestions?.indexOf(editProfileQuestions?.find(x => x?.question === 'Show City')),
                    e,
                    false,
                    '',
                    false,
                    true
                  )
                }}
                checked={
                  editProfileQuestions[
                    getQuestionIndex(
                      editProfileQuestions?.find(x => x?.question === 'Show City')?.question,
                      editProfileQuestions
                    )
                  ]?.userAnswer === 'true'
                    ? true
                    : false
                }
              />
              <Typography variant="body2">Show</Typography>
            </Box>
          )}
        </Box>
        <Box width="100%">
          {isUSOrCanada && (
            <Select
              value={location[2]}
              width="100%"
              theme={theme}
              menuItemList={cities
                ?.find(val => val.state === location[1]?.trim() && val.country === location[0].trim())
                ?.cities.map(val => ({ ...val, value: val?.label }))}
              fullWidth
              disableUnderline
              startAdornment={
                <StyledInputAdornment position="start">
                  <LocationCity />
                </StyledInputAdornment>
              }
              MenuProps={{ classes: { paper: classes.select } }}
              onChange={(e: any) => {
                handleSelect(2, e)
                handleChange(questionIndex, location, false, '', true)
              }}
            ></Select>
          )}
          {!isUSOrCanada && (
            <InputFieldGroup
              value={location[2] === 'undefined' ? '' : location[2]}
              fullWidth
              onChange={(e: any) => {
                handleSelect(2, e)
                handleChange(questionIndex, location, false, '', true)
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
